(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/helpers/helpers.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/helpers/helpers.js');
'use strict';

const isServer = typeof exports === 'object';
const getPreDefinedLimitsSupporternEnabled = () => {
  var _svs$playerRegistrati;
  return (_svs$playerRegistrati = svs.playerRegistration.data) === null || _svs$playerRegistrati === void 0 ? void 0 : _svs$playerRegistrati.preDefinedLimitsSupporternEnabled;
};

const getIsInRegisterFlow = setLimitsFromRedux => Boolean(!setLimitsFromRedux && !svs.utils.url.queryString.setLimits);
const getReturnUrl = () => {
  var _svs, _svs2;
  const returnUrlFromModel = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.playerRegistration) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.returnUrl) === null || _svs === void 0 ? void 0 : _svs.url) || ((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.playerRegistration) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 ? void 0 : _svs2.returnUrl);
  const queryUrl = svs.utils.url.queryString.returnUrl;
  const isInRegisterFlow = getIsInRegisterFlow();
  const backupReturnUrl = isInRegisterFlow ? svs.core.urlMapping.get('newCustomer') : svs.core.urlMapping.get('startPage');
  return svs.utils.url.makeInternal(returnUrlFromModel || queryUrl, backupReturnUrl);
};

const getUserAge = date => {
  const parsedDate = dateFns.parse(date, 'yyyyMMdd', new Date());
  return dateFns.differenceInYears(new Date(), parsedDate);
};

const getUnderTwenty = preferencesThirty => Boolean((preferencesThirty === null || preferencesThirty === void 0 ? void 0 : preferencesThirty.birthdate) && getUserAge(preferencesThirty.birthdate) < 20);
const getIsResume = () => svs.playerRegistration.data.isResume;

const getDevice = req => {
  let deviceType;
  switch (isServer ? req === null || req === void 0 ? void 0 : req.capabilities.channel : svs.core.data.capabilities.channel) {
    case 'ios-hybrid-mobile':
    case 'android-hybrid-mobile':
      deviceType = 5;
      break;
    case 'ios-hybrid-tablet':
    case 'android-hybrid-tablet':
      deviceType = 6;
      break;
    case 'web-mobile':
      deviceType = 1;
      break;
    case 'web-tablet':
      deviceType = 2;
      break;
    case 'web-desktop':
      deviceType = 3;
      break;
    default:
      deviceType = 1;
  }
  return deviceType;
};

const validateEmail = email => {
  if (!email.length || email.length > 200) {
    return false;
  }
  const emailReg = /^([\w.%+-]+@([\w-]+\.)+\w{2,10})?$/;
  return emailReg.test(email);
};

const validatePhoneNumber = phoneNumber => {
  const phoneNumberRegExp = /^(07\d{8}|(00|\+)?46\d{9})$/;
  phoneNumber = phoneNumber.replace(/-|\s/g, '');
  return !phoneNumber.length || phoneNumberRegExp.test(phoneNumber);
};

const removeUrlAfterPayServerAsync = () => new Promise(resolve => {
  svs.core.userSession.remove('urlafterpayserver', () => {
    resolve();
  });
});
if (isServer) {
  module.exports = {
    getDevice
  };
} else {
  svs.playerRegistration.helpers = {
    getPreDefinedLimitsSupporternEnabled,
    getReturnUrl,
    getUnderTwenty,
    getIsInRegisterFlow,
    getIsResume,
    getDevice,
    removeUrlAfterPayServerAsync,
    validateEmail,
    validatePhoneNumber
  };
}

 })(window);